<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="structure-bnxt" id="calibre_pb_5"><img alt="" class="_idgenobjectattribute3" src="OEBPS/image/Artwork_1131.png"/></p>
<p class="basic-paragraph1"><span class="charoverride">by</span><span class="charoverride"> </span><img alt="" class="_idgenobjectattribute1" src="OEBPS/image/Artwork_114.png"/></p>
<p class="basic-paragraph2"><span class="charoverride1">50 Easy &amp; Tasty Recipes Using<br class="calibre2"/>the Best Ingredients<br class="calibre2"/>from the Grocery Store</span></p>
<p class="basic-paragraph3"><span class="bold">Bobby Parrish and Dessi Parrish</span></p>
<p class="basic-paragraph4"><span class="charoverride2"><img alt="" class="_idgenobjectattribute4" src="OEBPS/image/Mango_Publishing_Group.png"/></span></p>
<p class="basic-paragraph5" id="calibre_pb_6"><span class="charoverride3">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_002.vue?3db308f4